import * as React from "react";

import { useProvidedState } from "@shared-ui/provided-state-context";

import { FlexComponent } from "typings/flexFramework/FlexComponent";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

import { ClientWizardStateStore } from "stores/wizard/ClientWizardStateStore";
import { WizardWithHeroImage } from "./components/WizardWithHeroImage";
import { WizardForTripsHero } from "./components/WizardForHeroTrips";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

export interface WizardHeroProps {
  wizardLOBs: FlexComponent[];
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tabName: string, rfrrId?: string) => void;
  context: ExtendedContextStore;
  heroImageFigureClassNames: string;
  heroImageSrc: string;
  wizardState: ClientWizardStateStore;
}

export const WizardHero: React.FC<WizardHeroProps> = (props) => {
  const { Trip_Hero_Web } = Experiment;
  const { context } = props;
  const [data] = useProvidedState();
  const [isLoaded, setIsLoaded] = React.useState(false);
  const isTripsHeroBucketed = isVariantEnabled(context, Trip_Hero_Web, 1);

  React.useEffect(() => {
    setIsLoaded(true);
  }, []);

  const shouldSSRTripsHeroWizard = isTripsHeroBucketed && !isLoaded;
  const shouldCSRTripsHeroWizard = data?.tripsHero?.isRendered && isLoaded;

  if (shouldSSRTripsHeroWizard || shouldCSRTripsHeroWizard) {
    return <WizardForTripsHero {...props} />;
  }

  return <WizardWithHeroImage {...props} />;
};
